var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-list-providers',{attrs:{"study":_vm.study,"providers":_vm.providersEnable,"album-id":_vm.source.key === 'album' ? _vm.source.value : ''},on:{"dropdownState":_vm.setShowIcons}})}
var staticRenderFns = []

export { render, staticRenderFns }